import { FormControl, Grid, MenuItem, Select, TextField, Typography } from '@mui/material';
import { makeStyles } from "@mui/styles";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Input } from '../../components';
import Header from "../../components/Header";
import { Form, useForm } from "../../components/form/UseForm";
import { instantFeedbackFields, InstantFormListData, formFields, instantFormFields } from './fields';
const useStyles = makeStyles({
    headings: {
        fontSize: ".875rem",
        color: "#00095b"
    },

});
const InstantFeedbackForm = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const { id } = useParams()
    useEffect(() => {
        window.onpopstate = function (event) {
            window.history.go(1);
        };
    }, []);
    const initialFValues = {
        name: "",
        regNo: "",
        serviceAdvisor: "",
        dateServiced: "",
        remarks:"",
        select1: " ",
        select2: " ",
        select3: " ",
        select4: " ",
        select5: " ",
        select6: " ",
        select7: " ",
        select8: " ",
        select9: " ",
        select10: " ",
        select11: " ",

    };

    // const [errors,setErrors]=useState({})

    const [error, setError] = useState("");

    const validate = (fieldValues = values) => {
        let temp = { ...errors };
        instantFormFields?.forEach((f: any) => {
            if (f.key in fieldValues) {
                
                temp[f.key] = fieldValues[f.key] ? "" : f.helperText;
            }


        })

        if("remarks" in fieldValues){
            temp["remarks"] = fieldValues["remarks"] ? "" : "Please enter remark";
        }

        setErrors({
            ...temp,
        });

        // Check if any field has error return false else true.
        if (fieldValues == values) return Object.values(temp).every((x) => x == "");
    };
    // Custom useForm hook.
    const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
        useForm({ initialFValues, validateOnChange: true, validate });
    const onInputChange = (e: any) => {
        setError("")
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });
        validate({ [name]: value });

    };

    const onSubmit = (e: any) => {
        e.preventDefault()

    }
    return (
        <Grid container >
            <Header position={'static'} />

            <Form style={{ padding: "20px 10px 20px 30px" }}>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} textAlign={'center'}>
                        <Typography variant="h4" className={classes.headings}>Instant Feedback</Typography>

                    </Grid>
                    <Grid item xs={12} sm={3}>
                    </Grid>
                    <Grid item xs={12} sm={6} textAlign={'center'}>
                        <Grid container spacing={2}>

                            {instantFeedbackFields?.map((f: any) => {
                                return <Grid item key={f.key} xs={12} sm={12} textAlign={'left'}>
                                    <div style={{ marginBottom: '5px' }}>{f.label}</div>
                                    <FormControl fullWidth>

                                        <Select
                                            labelId="demo-simple-select-label"
                                            id={f.key}
                                            value={values[f.key]}
                                            placeholder={f.label}
                                            size={'small'}
                                            onChange={onInputChange}
                                            error={errors[f.key]}
                                        >
                                            <MenuItem value={" "}>Select</MenuItem>
                                            {InstantFormListData?.map((i: any) => {
                                                return <MenuItem value={i.value}>{i.label}</MenuItem>
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            })}
                            {instantFormFields?.map((f: any) => {
                                return <Grid item key={f.key} xs={12} sm={6} textAlign={'left'}>
                                    <div style={{ marginBottom: '5px' }}>{f.label} <span style={{ color: 'red' }}>*</span></div>
                                    <Input
                                        required={f.required}
                                        //  disabled={f.disabled}
                                        // label={f.label}
                                        placeholder={f.label}
                                        name={f.key}
                                        type={f.type}
                                        value={values[f.key]}
                                        onChange={onInputChange}
                                        error={errors[f.key]}
                                        size={'small'}
                                    ></Input>
                                </Grid>
                            })}
                            <Grid item xs={12} sm={12} textAlign={'left'}>
                                <Typography variant='h6' color={"#00095b"} marginTop={"30px"}>Thank you for visiting our Dealership & sharing your valuable time!</Typography>
                                <div style={{ marginBottom: '5px' }}>Suggestion/Remarks <span style={{ color: 'red' }}>*</span></div>
                                <Input
                                    required={true}
                                    // label={f.label}
                                    placeholder={"Enter Suggestion/Remarks"}
                                    name={'remarks'}
                                    type={'text'}
                                    value={values['remarks']}
                                    onChange={onInputChange}
                                    error={errors['remarks']}
                                    size={'small'}
                                    multiline={true}
                                    fullWidth
                                    minRows={4}
                                  minLength={20}

                                ></Input>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                    </Grid>
                    <Grid item xs={12} sm={12} textAlign={'center'}>
                        <Button
                            name="Submit"
                             disabled={!values.name||!values.serviceAdvisor||!values.regNo||!values.dateServiced||!values.remarks}
                            type="submit"
                            onClick={(e: any) => {
                                onSubmit(e);
                            }}
                        />

                        <Typography color={"#00095b"} marginTop={"20px"}>Action Taken By Dealership on Feedback</Typography>
                    </Grid>

                </Grid>

            </Form>
        </Grid>
    );
};

export default InstantFeedbackForm;
